import React, { useState } from "react";
import CommodityGroup from "./pesticide_summary/CommodityGroup";
import classNames from "classnames";
import Button from "../Button";
import styled from "styled-components";
import { MinimalContainer } from "./Theme";

const Container = styled(MinimalContainer)`
  padding: 20px;
  max-width: 1920px;
  margin: 0 auto;
  margin-top: 20px;
`;

export default function PesticideSummaryReport({ data, options }) {
  const [selectedCommodity, setSelectedCommodity] = useState(null);

  const displayCommodityGroups = selectedCommodity
    ? [selectedCommodity]
    : data.commodity_groups;

  const downloadExcelFile = () => {
    var html = document
      .getElementById("pesticide_summary_report")
      .innerHTML.replace(/<\/?br>/g, "");
    download(html, "pesticide_summary_report.xls", "application/vnd.ms-excel");
  };

  return (
    <Container>
      <div className="row">
        {data.commodity_groups.length > 1 && (
          <div className="col-md-2">
            <ul className="nav nav-pills nav-stacked pesticide-commodity-list">
              <li>
                <Button
                  title="Show All"
                  small={true}
                  block={true}
                  primary={selectedCommodity === null}
                  onClick={() => setSelectedCommodity(null)}
                />
              </li>
              {data.commodity_groups.map((commodityGroup) => (
                <li>
                  <Button
                    small={true}
                    block={true}
                    title={commodityGroup.mrl_product_name}
                    primary={selectedCommodity === commodityGroup}
                    onClick={() => setSelectedCommodity(commodityGroup)}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
        <div
          className={classNames("pesticide_summary_report", {
            "col-md-10": data.commodity_groups.length > 1,
            "col-md-12": data.commodity_groups.length == 1,
          })}
        >
          {data && (
            <p style={{ textAlign: "left", marginTop: 0, marginBottom: 20 }}>
              <Button
                title="Download as Excel"
                onClick={downloadExcelFile}
                icon="fa-download"
              />
            </p>
          )}
          <div id="pesticide_summary_report">
            {displayCommodityGroups.map((commodityGroup) => (
              <CommodityGroup
                key={commodityGroup.mrl_product_name}
                data={commodityGroup}
                attribute_types={data.attribute_types}
                options={options}
              />
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}
